exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.QS420_mobile_video_witness[data-v-0682c380]{height:100%\n}", "", {"version":3,"sources":["/home/jenkins/workspace/pipeline-10323-UAT-kmos-web-ci-cd-6005/html/PC/src/business/businessFile/QS420/QS420_mobile_video_witness.vue"],"names":[],"mappings":";AACA,6CAA6C,WAAW;CACvD","file":"QS420_mobile_video_witness.vue","sourcesContent":["\n.QS420_mobile_video_witness[data-v-0682c380]{height:100%\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0682c380","scoped":true,"hasInlineConfig":false}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./node_modules/style-rem-loader??ref--1!./src/business/businessFile/QS420/QS420_mobile_video_witness.vue
// module id = 1216
// module chunks = 2